import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Bridge, SignOut, User } from "@phosphor-icons/react";

const ROLE_LABEL = { company: "Company", hotel_gm: "Management Company / Group Admin", gm: "General Manager", rm: "Regional Manager", dos: "Director of Sales", sales: "Sales Manager", front_desk: "Front Desk" };

const LINKS = {
  company: [
    { to: "/marketplace", label: "Find Hotels" },
    { to: "/company", label: "My Dashboard" },
  ],
  hotel_gm: [
    { to: "/hotel", label: "Dashboard" },
    { to: "/prospect", label: "Find Prospects" },
    { to: "/marketplace", label: "Browse Market" },
    { to: "/roles", label: "Roles" },
  ],
  gm: [
    { to: "/gm", label: "Dashboard" },
    { to: "/prospect", label: "Find Prospects" },
    { to: "/roles", label: "Roles" },
  ],
  rm: [
    { to: "/gm", label: "Dashboard" },
    { to: "/prospect", label: "Find Prospects" },
    { to: "/roles", label: "Roles" },
  ],
  dos: [
    { to: "/gm", label: "Dashboard" },
    { to: "/prospect", label: "Find Prospects" },
    { to: "/roles", label: "Roles" },
  ],
  sales: [
    { to: "/sales", label: "My Leads" },
    { to: "/prospect", label: "Find Prospects" },
  ],
  front_desk: [
    { to: "/front-desk", label: "Guest Enquiry" },
  ],
};

export default function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  if (!user) return null;
  const links = LINKS[user.role] || [];

  const doLogout = () => { logout(); navigate("/login"); };

  return (
    <header className="glass-header sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-10">
          <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#002FA7] flex items-center justify-center">
              <Bridge size={20} weight="bold" color="#fff" />
            </div>
            <span className="flex flex-col leading-none">
              <span className="font-display font-bold text-xl tracking-tight text-[#111827]">
                Rate<span className="text-[#002FA7]">Bridge</span>
              </span>
              <span className="text-[10px] text-[#9CA3AF] tracking-wide" data-testid="nav-tagline">by Cipher Technologies</span>
            </span>
          </Link>
          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm font-medium transition-colors ${isActive ? "text-[#002FA7]" : "text-[#4B5563] hover:text-[#111827]"}`}>
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>

        <div className="flex items-center gap-4">
          <div className="hidden sm:flex flex-col items-end leading-tight">
            <span className="overline text-[#4B5563]">{ROLE_LABEL[user.role]}</span>
            <span className="text-sm font-semibold text-[#111827] max-w-[200px] truncate" data-testid="nav-user-name">
              {user.company_name || user.name}
            </span>
          </div>
          <div className="w-9 h-9 bg-[#111827] text-white flex items-center justify-center" title={user.name}>
            <User size={18} weight="bold" />
          </div>
          <button onClick={doLogout} data-testid="logout-btn"
            className="flex items-center gap-1.5 border border-[#E5E7EB] px-3 py-2 text-xs font-semibold text-[#4B5563] hover:border-[#DC2626] hover:text-[#DC2626] transition-colors active:scale-[0.97]">
            <SignOut size={16} weight="bold" /> <span className="hidden sm:inline">Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
}
